import { render, staticRenderFns } from "./CartesianEdit.vue?vue&type=template&id=6c1403b4&scoped=true"
import script from "./CartesianEdit.vue?vue&type=script&lang=js"
export * from "./CartesianEdit.vue?vue&type=script&lang=js"
import style0 from "./CartesianEdit.vue?vue&type=style&index=0&id=6c1403b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1403b4",
  null
  
)

export default component.exports